module.exports = __webpack_public_path__ + "img/foro2024_footer_mobile.9c3e59d7.jpg";